import { withStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import styles from './styles'
import { useDispatch } from 'react-redux'
import {
  AccessTeams,
  OptIn,
  AuthenticatedLinks,
  MagicViewContent,
  EveryoneAccess,
  PaymentWall,
} from './components'
import PaidAccess from './components/payment-wall/components/paid-access'
import {
  getCollectionSettingsAction,
  patchCollectionSettingsAction,
} from 'src/reducers/collection/action'
import { useSelector } from 'react-redux'
import { PatchContent, PatchData } from 'src/model/patch'
import UserType from 'src/model/user-types'
import { track } from '@amplitude/analytics-browser'
import PaymentGateway from 'src/model/payment-providers'
import PaymentOptions from './components/payment-wall/components/data/payment-options'
import { hasInAppAuthAccess } from './utils/in-app-auth-access'

const names = {
  0: 'Everyone',
  1: 'Opt-in',
  2: 'Specific Teams',
  3: 'Authenticated Links',
  4: 'Payment wall',
}

const GeneralSettings = props => {
  const { classes, modal, collectionId, price, onSave } = props
  const [magicLink, setMagicLink] = useState(false)

  const dispatch = useDispatch()
  const collection = useSelector(state => state.collection.collection)
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )
  const [paidAccessView, setPaidAccessView] = useState(false)

  function getPaymentGatewayText(value) {
    for (const gateway in PaymentGateway) {
      if (PaymentGateway[gateway] === value) {
        return gateway
      }
    }
    return null
  }

  const providerText = getPaymentGatewayText(
    collectionSettings?.paymentProvider,
  )
  const paymentConfigured = collectionSettings?.isPaymentConfigured
  const [paymentProvider, setPaymentProvider] = React.useState(providerText)
  const [paymentLink, setPaymentLink] = React.useState(
    collectionSettings?.paymentLink || '',
  )
  const [
    paymentSettingsConfigured,
    setPaymentSettingsConfigured,
  ] = React.useState(paymentConfigured)
  const [accessRule, setAccessRule] = useState(
    collectionSettings?.accessRule || 0,
  )

  useEffect(() => {
    if (collectionId) {
      dispatch(getCollectionSettingsAction(collectionId, response => { }))
    }
  }, [collectionId, dispatch])

  useEffect(() => {
    if (collectionSettings) {
      setAccessRule(collectionSettings?.accessRule || 0)
      setPaymentLink(collectionSettings?.paymentLink || '')
      setPaymentSettingsConfigured(collectionSettings?.isPaymentConfigured)
      setPaymentProvider(
        getPaymentGatewayText(collectionSettings?.paymentProvider),
      )
      setPaidAccessView(collectionSettings?.accessRule === 4)
    }
  }, [collectionSettings])

  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]

  const onClickDone = clickedBeforeFinish => {
    const patchSource = new PatchData(
      null,
      collectionId ? collectionId : collection.id,
    )
    patchSource.addContent(
      new PatchContent(
        true,
        'isPaymentConfigured',
        PatchData.OPERATION_REPLACE,
      ),
    )
    dispatch(
      patchCollectionSettingsAction(patchSource, response => {
        if (!clickedBeforeFinish) {
          setPaymentSettingsConfigured(true)
        }
        if (onSave && typeof onSave === 'function') {
          onSave()
        }
      }),
    )
  }

  const onClickEdit = () => {
    setPaidAccessView(true)
  }

  const handleSaveAccessSelection = value => {
    const patchSource = new PatchData(
      null,
      collectionId ? collectionId : collection.id,
    )
    patchSource.addContent(
      new PatchContent(value, 'accessRule', PatchData.OPERATION_REPLACE),
    )

    if (value !== 4 && paymentProvider !== '') {
      patchSource.addContent(
        new PatchContent(null, 'paymentProvider', PatchData.OPERATION_REPLACE),
      )
      setPaymentProvider(null)
      patchSource.addContent(
        new PatchContent(null, 'paymentLink', PatchData.OPERATION_REPLACE),
      )
      setPaymentLink('')
      patchSource.addContent(
        new PatchContent(
          false,
          'isPaymentConfigured',
          PatchData.OPERATION_REPLACE,
        ),
      )
      setPaymentSettingsConfigured(false)
    }
    dispatch(
      patchCollectionSettingsAction(patchSource, response => {
        track('Access Rule Changed', {
          from: names[value],
        })
        // Trigger refresh to update the collection card
        if (onSave && typeof onSave === 'function') {
          onSave()
        }
      }),
    )
  }

  const handleBack = () => {
    setMagicLink(false)
  }

  const handleBackFromPaidAccess = () => {
    setPaidAccessView(false)
  }

  const appInAuthUsersControl = () => {
    return !hasInAppAuthAccess(userControl)
  }

  const handleAccessRule = value => {
    let userAccessControl = false

    if (value === 3) {
      userAccessControl = appInAuthUsersControl()
      if (userAccessControl) {
      }
    }

    if (value !== accessRule) {
      setAccessRule(value)
      handleSaveAccessSelection(value)
    }

    if (value === 4) {
      setPaidAccessView(true)
    }

    if (value !== 4) {
      const collectionElement = document.querySelector(
        `[data-collection-id="${collectionId || collection?.id}"]`,
      )
      if (collectionElement) {
        const priceElement = collectionElement.querySelector('.section-price p')
        if (priceElement) {
          priceElement.textContent = 'Free'
        }
      }
    }
  }

  const handleMagicLink = () => {
    setMagicLink(!magicLink)
  }

  const closeDrawer = () => {
    //setCollectionSettingDrawerOpen(false)
  }

  const components = [
    {
      component: (
        <EveryoneAccess
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
        />
      ),
      onView: !magicLink && !paidAccessView,
      mainPage: true,
    },
    {
      component: (
        <OptIn
          collectionId={collectionId}
          entity={collection}
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
        />
      ),
      onView: !magicLink && !paidAccessView,
      mainPage: true,
    },
    {
      component: (
        <PaymentWall
          collectionId={collectionId}
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
          entity={collection}
          setPaymentProvider={setPaymentProvider}
          setPaymentSettingsConfigured={setPaymentSettingsConfigured}
          setPaymentLink={setPaymentLink}
          modal={modal}
          onClickEdit={onClickEdit}
        />
      ),
      onView: !magicLink && !paidAccessView,
      mainPage: true,
    },
    {
      component: (
        <AccessTeams
          entity={collection}
          collectionIds={collectionId}
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
          dispatch={dispatch}
          handleMagicLink={handleMagicLink}
        />
      ),
      onView: !magicLink && !paidAccessView,
      mainPage: true,
    },
    {
      component: (
        <AuthenticatedLinks
          accessRule={accessRule}
          handleAccessRule={handleAccessRule}
        />
      ),
      onView: !magicLink && !paidAccessView,
      mainPage: true,
    },
    {
      component: (
        <MagicViewContent
          entity={collection}
          accessRule={accessRule}
          handleBack={handleBack}
          closeDrawer={closeDrawer}
          collectionSettings={collectionSettings}
        />
      ),
      onView: magicLink,
      mainPage: false,
    },
    {
      component: (
        <PaidAccess
          collectionId={collectionId}
          entity={collection}
          setPaymentLink={setPaymentLink}
          setPaymentSettingsConfigured={setPaymentSettingsConfigured}
          setPaymentProvider={setPaymentProvider}
          onClickDone={onClickDone}
          handleBack={handleBackFromPaidAccess}
          showBackButton={true}
        />
      ),
      onView: paidAccessView,
      mainPage: false,
    },
  ]

  return (
    <div className={classes.content}>
      <div className={classes.content__components}>
        {components.map(
          (component, index) =>
            component.onView && (
              <div className={classes.componentDiv} key={index}>
                {component.component}
              </div>
            ),
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(GeneralSettings)
